export default __webpack_public_path__ + "static/media/Tumultuous Thunder.109560f7.jpg";